import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _ts_generator from "@swc/helpers/src/_ts_generator.mjs";
import { useState } from "react";
import { getApi } from "./axios";
export var useClientSideRequest = function(apiHost, apiRoute) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
        withCredentials: true
    };
    var ref = useState(null), data = ref[0], setData = ref[1];
    var ref1 = useState(null), error = ref1[0], setError = ref1[1];
    var api = getApi(apiHost, _object_spread({}, options));
    return {
        request: function() {
            var _ref = _async_to_generator(function(method, params) {
                var result, e;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                api.request({
                                    method: method,
                                    url: apiRoute,
                                    params: params
                                })
                            ];
                        case 1:
                            result = _state.sent();
                            setData(result === null || result === void 0 ? void 0 : result.data);
                            return [
                                3,
                                3
                            ];
                        case 2:
                            e = _state.sent();
                            setError(e.message);
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(method, params) {
                return _ref.apply(this, arguments);
            };
        }(),
        data: data,
        error: error
    };
};
